import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { AuthService } from '../../service/auth.service';
import { EcomicService } from '../../service/comics/ecomic.service';
declare const swal: any;
declare var $: any;
@Component({
  selector: 'app-email-history',
  templateUrl: './email-history.component.html',
  styleUrls: ['./email-history.component.css']
})
export class EmailHistoryComponent implements OnInit {
  AllSentEmails=[];
  EmailDetails: any;
  isShowDetails:boolean=false;

  constructor(private form: FormBuilder, private router: Router, private afs: AngularFirestore, private comicService: EcomicService,
    private route: ActivatedRoute, private auth: AuthService, public toastr: ToastsManager, vcr: ViewContainerRef,private http:HttpClient) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  ngOnInit() {
    this.GetEmails();
  }
 async GetEmails(){
  try {

    const emails = await this.afs.collection(`SentEmails`, res => {
      return res.orderBy('createdAt',"desc");
    });
    const data = await emails.valueChanges();
    data.subscribe(async (response)=>{
      this.AllSentEmails = response;
      console.log(this.AllSentEmails)
      this.AllSentEmails.forEach(element => {
        // if(element.type == "Individual"){
        //   this.afs.doc('/Offers/'+element.id).delete().then(function () {  })
        // }
      });
    })
    
  } catch (error) {
    throw error;
  }
 }
 View(Data) {
  console.log(Data)
  this.EmailDetails = Data;
  this.isShowDetails=true;
  // $("#ViewEmailModal").modal();
}
close(){
  this.isShowDetails=false;
}
}



// WEBPACK FOOTER //
// ./src/app/send-email/email-history/email-history.component.ts